<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <p-skeleton width="10rem" height="1.5rem" class="mb-2" />
        <p-skeleton width="16rem" height="0.875rem" />
      </div>
      <div class="flex-1 min-h-0 overflow-auto p-4 space-y-2">
        @for (row of skeletonRows; track row) {
          <p-skeleton height="2.5rem" />
        }
      </div>
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <p class="text-red-800">{{ error() }}</p>
      <button (click)="loadTemplates()" class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg">Reintentar</button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-rose-100 text-rose-600">
                  <i class="pi pi-envelope"></i>
                </span>
                Comunicación
              </h2>
              <p class="text-sm text-slate-500 mt-1">Plantillas de correo y mensajes.</p>
            </div>
            <a routerLink="/comunicacion/nuevo" appDisableUnless="COMMUNICATION_TEMPLATE_WRITE">
              <p-button label="Nueva plantilla" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="COMMUNICATION_TEMPLATE_WRITE" />
            </a>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-end gap-2">
            <div class="min-w-0 col-span-2 sm:flex-1 sm:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterCommQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterCommQ">Nombre o asunto</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 sm:w-36" variant="on">
              <p-select formControlName="type" inputId="filterCommType" [options]="typeOptions" optionLabel="label" optionValue="value" size="small" [showClear]="true" class="w-full" />
              <label for="filterCommType">Tipo</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 sm:w-32" variant="on">
              <p-select formControlName="state" inputId="filterCommState" [options]="stateOptions" optionLabel="label" optionValue="value" size="small" [showClear]="true" class="w-full" />
              <label for="filterCommState">Estado</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end">
                <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" severity="secondary" type="button" (onClick)="clearFilters()" ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="templates()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} plantillas"
            [loading]="loading()"
            [paginator]="true"
            (onLazyLoad)="onLazyLoad($event)"
            styleClass="communication-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Plantilla</th>
                <th>Tipo</th>
                <th>Asunto</th>
                <th>Estado</th>
                <th class="!text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template>
              <tr class="cursor-pointer hover:!bg-rose-50/40 transition-colors" (click)="editTemplate(template)">
                <td>
                  <div class="flex items-center gap-2 min-w-0">
                    <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-rose-100 text-rose-600">
                      <i class="pi pi-file-edit text-sm"></i>
                    </span>
                    <span class="text-sm font-medium text-slate-900 truncate">{{ template.name }}</span>
                  </div>
                </td>
                <td class="text-sm text-slate-700">{{ getCommunicationTypeLabel(template.type) }}</td>
                <td class="text-sm text-slate-600 max-w-xs truncate">{{ template.subject }}</td>
                <td>
                  <p-tag class="!text-xs" [value]="template.state === 'ACTIVE' ? 'Activo' : 'Inactivo'" [severity]="getStateSeverity(template.state)" />
                </td>
                <td class="!text-right" (click)="$event.stopPropagation()">
                  <p-button icon="pi pi-ellipsis-v" [rounded]="true" [text]="true" severity="secondary" (onClick)="openRowMenu($event, template)" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="!text-center !py-10 text-slate-500">No hay plantillas que coincidan con los filtros.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }
</div>
</div>

<p-menu #rowMenu [popup]="true" [model]="rowMenuItems" appendTo="body" />
